// extracted by mini-css-extract-plugin
export default {"form":"MealsForm_form__8CgID"};